import React from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface CreateOtorganteDialogProps {
  open: boolean;
  nombre: string;
  dni: string;
  telefono: string;
  email: string;
  isSubmitting: boolean;
  error: string | null;
  onClose: () => void;
  onChange: (values: Partial<{ nombre: string; dni: string; telefono: string; email: string; error: string | null }>) => void;
  onSubmit: (values: { nombre: string; email: string; dni?: string; telefono?: string }) => Promise<void>;
}

export const CreateOtorganteDialog: React.FC<CreateOtorganteDialogProps> = ({
  open,
  nombre,
  dni,
  telefono,
  email,
  isSubmitting,
  error,
  onClose,
  onChange,
  onSubmit,
}) => (
  <Dialog open={open} onOpenChange={(state) => {
    if (!state) onClose();
  }}>
    <DialogContent className="max-w-md max-h-[90dvh] overflow-y-auto">
      <form
        onSubmit={async (event) => {
          event.preventDefault();
          await onSubmit({ nombre, dni, telefono, email });
        }}
        className="space-y-4"
      >
        <DialogHeader>
          <DialogTitle>Nuevo otorgante</DialogTitle>
          <DialogDescription>
            Completá los datos de contacto del otorgante para vincularlo al trámite.
            Se creará automáticamente un usuario con una contraseña temporal.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3">
          <div className="space-y-2">
            <Label htmlFor="otorgante-nombre">Nombre</Label>
            <Input
              id="otorgante-nombre"
              value={nombre}
              onChange={(event) => onChange({ nombre: event.target.value })}
              required
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="otorgante-dni">DNI</Label>
            <Input
              id="otorgante-dni"
              value={dni}
              onChange={(event) => onChange({ dni: event.target.value })}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="otorgante-telefono">Teléfono</Label>
            <Input
              id="otorgante-telefono"
              value={telefono}
              onChange={(event) => onChange({ telefono: event.target.value })}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="otorgante-email">Email *</Label>
            <Input
              id="otorgante-email"
              type="email"
              value={email}
              onChange={(event) => onChange({ email: event.target.value })}
              required
              placeholder="ejemplo@email.com"
            />
            <p className="text-xs text-muted-foreground">
              Requerido para crear el usuario en el sistema
            </p>
          </div>
        </div>

        {error && <p className="text-sm text-rose-600">{error}</p>}

        <DialogFooter className="gap-3 pt-2">
          <Button type="button" variant="outline" onClick={onClose} disabled={isSubmitting}>
            Cancelar
          </Button>
          <Button type="submit" loading={isSubmitting} disabled={isSubmitting}>
            Guardar otorgante
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);
